import { Navigate } from "react-router-dom";

import {
  Login,
  UserProfileOverview,
  EditProfile,
  EditMatchPreference,
  EditTrustBadge,
  Overview,
  KeyMetrics,
  RecentActivities,
  UserList,
  DeletedUsers,
  DeactivatedUsers,
  ExpiredUsers,
  OrderList,
  PlansAndPricing,
  PromoCodes,
  PaymentGateway,
  BillingHistory,
  PhotosPending,
  PhotosGallery,
  UserProfileRequests,
  CurrentPlan,
  TransactionLogs,
  ActivityLogs,
  ActivityTimeline,
  UsageAnalytics,
  NotificationPref,
  Messages,
  AccountStatus,
  GeneralSettings,
  MoneyPage,
  MoneyPageDetails,
  AddMoneyPage,
  Blog,
  BlogDetails,
  AddBlog,
  Author,
  AuthorDetails,
  AddAuthor,
  AddCategory,
  Category,
  CategoryDetails,
  CountryChange,
  GenderChange,
  DobChange,
  MatchDescription,
  TrustBadgeChange,
  ProfileDescriptionChange,
  UserFeedback,
} from "../../containers";

export const routes = {
  protected: {
    // dashboard
    overview: "/dashboard/overview",
    keyMetrics: "/dashboard/keyMetrics",
    recentActivities: "/dashboard/recentActivities",

    //user Overviews
    userProfileOverview: "/userprofileoverview/:id",
    photosPending: "/userprofileoverview/:id/photos/photospending",
    photosGallery: "/userprofileoverview/:id/photos/photosgallery",
    editUserProfile: "/userprofileoverview/:id/editUserProfile",
    editUserMatchPref: "/userprofileoverview/:id/editUserMatchPref",
    editUserTrustBadge: "/userprofileoverview/:id/editUserTrustBadge",
    currentPlan: "/userprofileoverview/:id/membership/currentplan",
    transactionLogs: "/userprofileoverview/:id/membership/transactionlogs",
    activityLogs: "/userprofileoverview/:id/settings/activitylogs",
    activityTimeline: "/userprofileoverview/:id/settings/activitytimeline",
    usageAnalytics: "/userprofileoverview/:id/settings/usageanalytics",
    notificationPref: "/userprofileoverview/:id/settings/notificationpref",
    messages: "/userprofileoverview/:id/settings/messages",
    accountStatus: "/userprofileoverview/:id/settings/accountstatus",

    // user requests
    genderchange: "/user-requests/genderchange",
    countryChange: "/user-requests/countrychange",
    dobChange: "/user-requests/dobchange",
    profileDescChange: "/user-requests/profileDescription",
    matchDescChange: "/user-requests/matchDescription",
    trustBadgeChange: "/user-requests/trustBadge",

    // user management
    userList: "/user-management/userList",
    deletedUsers: "/user-management/deletedUsers",
    deactivatedUsers: "/user-management/deactivatedUsers",
    expiredUsers: "/user-management/expiredUsers",

    // user requests
    userProfileRequest: "/userprofileoverview/:id/userrequests",

    // order management
    orderList: "/order-management/orderList",
    plansAndPricing: "/order-management/plansAndPricing",
    promoCodes: "/order-management/promoCodes",
    paymentGateway: "/order-management/paymentGateway",
    billingHistory: "/order-management/billingHistory",

    // Settings
    generalSettings: "/settings/generalsettings",

    // money page
    moneyPage: "/moneyPage",
    addMoneyPage: "/addMoneyPage",
    moneyPageDetails: "/moneyPage/:id",

    // blog
    blog: "/blog",
    addBlog: "/addBlog",
    blogDetails: "/blog/:id",

    // author
    author: "/author",
    addAuthor: "/addAuthor",
    authorDetails: "/author/:id",

    // category
    category: "/category",
    addCategory: "/addCategory",
    categoryDetails: "/category/:id",

    //support
    userfeedback: "/support/userfeedback",
  },
  public: {
    login: "/login",
  },
};

export const PROTECTED_ROUTES = [
  // dashboard
  {
    path: routes.protected.overview,
    exact: false,
    component: <Overview />,
  },
  {
    path: routes.protected.keyMetrics,
    exact: false,
    component: <KeyMetrics />,
  },
  {
    path: routes.protected.recentActivities,
    exact: false,
    component: <RecentActivities />,
  },
  // User Overview
  {
    path: routes.protected.userProfileOverview,
    exact: false,
    component: <UserProfileOverview />,
  },
  {
    path: routes.protected.photosPending,
    exact: false,
    component: <PhotosPending />,
  },
  {
    path: routes.protected.photosGallery,
    exact: false,
    component: <PhotosGallery />,
  },
  {
    path: routes.protected.editUserProfile,
    exact: false,
    component: <EditProfile />,
  },
  {
    path: routes.protected.editUserMatchPref,
    exact: false,
    component: <EditMatchPreference />,
  },
  {
    path: routes.protected.editUserTrustBadge,
    exact: false,
    component: <EditTrustBadge />,
  },
  {
    path: routes.protected.currentPlan,
    exact: false,
    component: <CurrentPlan />,
  },
  {
    path: routes.protected.transactionLogs,
    exact: false,
    component: <TransactionLogs />,
  },
  {
    path: routes.protected.activityLogs,
    exact: false,
    component: <ActivityLogs />,
  },
  {
    path: routes.protected.activityTimeline,
    exact: false,
    component: <ActivityTimeline />,
  },
  {
    path: routes.protected.usageAnalytics,
    exact: false,
    component: <UsageAnalytics />,
  },
  {
    path: routes.protected.userProfileRequest,
    exact: false,
    component: <UserProfileRequests />,
  },
  {
    path: routes.protected.notificationPref,
    exact: false,
    component: <NotificationPref />,
  },
  {
    path: routes.protected.messages,
    exact: false,
    component: <Messages />,
  },
  {
    path: routes.protected.accountStatus,
    exact: false,
    component: <AccountStatus />,
  },
  // user management
  {
    path: routes.protected.userList,
    exact: false,
    component: <UserList />,
  },
  {
    path: routes.protected.deletedUsers,
    exact: false,
    component: <DeletedUsers />,
  },
  {
    path: routes.protected.deactivatedUsers,
    exact: false,
    component: <DeactivatedUsers />,
  },
  {
    path: routes.protected.expiredUsers,
    exact: false,
    component: <ExpiredUsers />,
  },

  // user requests
  {
    path: routes.protected.genderchange,
    exact: false,
    component: <GenderChange />,
  },
  {
    path: routes.protected.countryChange,
    exact: false,
    component: <CountryChange />,
  },
  {
    path: routes.protected.dobChange,
    exact: false,
    component: <DobChange />,
  },
  {
    path: routes.protected.profileDescChange,
    exact: false,
    component: <ProfileDescriptionChange />,
  },
  {
    path: routes.protected.matchDescChange,
    exact: false,
    component: <MatchDescription />,
  },
  {
    path: routes.protected.trustBadgeChange,
    exact: false,
    component: <TrustBadgeChange />,
  },

  // order management
  {
    path: routes.protected.orderList,
    exact: false,
    component: <OrderList />,
  },
  {
    path: routes.protected.plansAndPricing,
    exact: false,
    component: <PlansAndPricing />,
  },
  {
    path: routes.protected.promoCodes,
    exact: false,
    component: <PromoCodes />,
  },
  {
    path: routes.protected.paymentGateway,
    exact: false,
    component: <PaymentGateway />,
  },
  {
    path: routes.protected.billingHistory,
    exact: false,
    component: <BillingHistory />,
  },
  // Settings
  {
    path: routes.protected.generalSettings,
    exact: false,
    component: <GeneralSettings />,
  },
  // Money page
  {
    path: routes.protected.moneyPage,
    exact: false,
    component: <MoneyPage />,
  },
  {
    path: routes.protected.moneyPageDetails,
    exact: false,
    component: <MoneyPageDetails />,
  },
  {
    path: routes.protected.addMoneyPage,
    exact: false,
    component: <AddMoneyPage />,
  },
  //Blog
  {
    path: routes.protected.blog,
    exact: false,
    component: <Blog />,
  },
  {
    path: routes.protected.blogDetails,
    exact: false,
    component: <BlogDetails />,
  },
  {
    path: routes.protected.addBlog,
    exact: false,
    component: <AddBlog />,
  },
  //author
  {
    path: routes.protected.author,
    exact: false,
    component: <Author />,
  },
  {
    path: routes.protected.authorDetails,
    exact: false,
    component: <AuthorDetails />,
  },
  {
    path: routes.protected.addAuthor,
    exact: false,
    component: <AddAuthor />,
  },
  //category
  {
    path: routes.protected.category,
    exact: false,
    component: <Category />,
  },
  {
    path: routes.protected.categoryDetails,
    exact: false,
    component: <CategoryDetails />,
  },
  {
    path: routes.protected.addCategory,
    exact: false,
    component: <AddCategory />,
  },
  // support
  {
    path: routes.protected.userfeedback,
    exact: false,
    component: <UserFeedback />,
  },
  {
    path: "*",
    exact: false,
    component: <Navigate to={routes.protected.overview} />,
  },
];

export const PUBLIC_ROUTES = [
  // login
  {
    path: routes.public.login,
    exact: false,
    component: <Login />,
  },

  {
    path: "*",
    exact: false,
    component: <Navigate to={routes.public.login} />,
  },
];
